var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLayersThree01 = function SvgLayersThree01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 13.692 1.51 8.096 12 2.5l10.5 5.596zm0 3.904-9.915-5.28 1.57-.862L12 15.889l8.354-4.435 1.571.861zm0 3.904-9.915-5.28 1.57-.862L12 19.792l8.354-4.434 1.571.861zm0-9.515 7.373-3.889L12 4.208 4.637 8.096z"
  })));
};
export default SvgLayersThree01;